const getParams = (url) => {
  if (!url) {
    return {};
  }
  const urlparts = url.split('#')[0].split('?')[1] || '';
  if (!urlparts) {
    return {};
  }
  return urlparts
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
};

const getParam = (param) => new URLSearchParams(window.location.search).get(param);

const removeURLParams = (paramKeys) => {
  const url = new URL(window.location.href);
  // Remove each specified parameter
  paramKeys.forEach((key) => url.searchParams.delete(key));
  // Update the browser URL without reloading
  window.history.replaceState({}, '', url);
};

export {getParams, getParam, removeURLParams};
